import { createSlice } from '@reduxjs/toolkit';
import { NetworkSliceState } from './networkSliceTypes';
import { RootState } from 'rootReducer';

const initialState: NetworkSliceState = {
  isRunning: false,
  status: null,
  offsetSeconds: 0,
  responseTime: 0,
};

export const networkSlice = createSlice({
  name: 'network',
  initialState,
  reducers: {
    setRunning: (state, action) => {
      state.isRunning = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setOffsetSeconds: (state, action) => {
      state.offsetSeconds = action.payload;
    },
    setResponseTime: (state, action) => {
      state.responseTime = action.payload;
    },
  },
});

export const selectIsRunning = (state: RootState): boolean => state.network.isRunning;
export const selectOffsetSeconds = (state: RootState): number => state.network.offsetSeconds;
export const selectResponseTime = (state: RootState): number => state.network.responseTime;

export const networkActions = networkSlice.actions;

export default networkSlice.reducer;
